// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/858e0a2c6323daf77f42.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"4d804037cc332bc33936","179":"55b25a5bb059fd801cf1","180":"0a9fcfdebe6660b32c0c"}[chunkId] + ".chunk.js";
};